import React, {useEffect, useState} from 'react';
import styles from './Login.module.scss';
import passVis from "../../assets/passVis.svg";
import passHide from "../../assets/passHide.svg";
import {getSeasonLogo} from '../../utils/season';
import {useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {authorization} from '../../api';
import {logout, setAuth} from '../../store/slices/auth';
import {useSnackbar} from '../../contexts/SnackbarContext';
import {jwtDecode} from "jwt-decode";
import {useNavigate} from "react-router-dom";
import {useTheme} from "../../contexts/ThemeProvider";
import {FestiveText} from "../../components/Holidays/FestiveText";
import {SpecialButton} from "../../components/Holidays/SpecialButton";
import {HolidayEnum} from "../../enums/holidayEnum";


export function Login() {
    const [isPassVis, setIsPassVis] = useState(false)
    const [login, setLogin] = useState('')
    const [isLoginError, setIsLoginError] = useState('')
    const [password, setPassword] = useState('')
    const [isPasswordError, setIsPasswordError] = useState('')
    const {t} = useTranslation();
    const {showSnackbar} = useSnackbar();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {theme} = useTheme()
    const isHalloween = theme.name === HolidayEnum.halloween;
    useEffect(() => {
        dispatch(logout())
    }, [dispatch])

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!login.trim()) {
            setIsLoginError(t('login_page.empty_login'));
            showSnackbar(t('login_page.empty_login'), 'error');
            return;
        }

        if (!password.trim()) {
            setIsPasswordError(t('login_page.empty_password'));
            showSnackbar(t('login_page.empty_password'), 'error');
            return;
        }

        try {
            const {token, refresh_token} = await authorization(login, password);
            if (token) {
                const decodedToken = jwtDecode(token)
                const brands = decodedToken.claim
                dispatch(setAuth({token, refresh_token, brands}));

                if (brands.length > 1) {
                    navigate('/');
                }
                if (brands.length === 1) {
                    const currentBrand = brands[0];
                    window.location.href = `${currentBrand?.url}/authorization/${token}/${refresh_token}`
                }
            }
        } catch (e) {
            showSnackbar(e.message, 'error');
        }
    };
    return (
        <div id={'loginPage'} className={styles.page} style={{backgroundImage: `var(--login-bg-img)`}}>
            <div className={styles.login}>
                <img src={getSeasonLogo()}  alt="logo" style={{zIndex: isHalloween? -1: 0}}/>
                <form id={'loginForm'} onSubmit={handleSubmit} >
                    <div className={`${styles.label_input} ${isLoginError ? styles.error : ''}`}>
                        <label htmlFor="login"><FestiveText>Login</FestiveText></label>
                        <input
                            id='login'
                            type="text"
                            placeholder='Login'
                            value={login}
                            onChange={e => setLogin(e.target.value)}
                        />
                    </div>
                    <div className={`${styles.label_input} ${isPasswordError ? styles.error : ''}`}>
                        <label htmlFor="pass"><FestiveText>Password</FestiveText></label>
                        <div className={styles.input_pass}>
                            <input
                                id='pass'
                                type={isPassVis ? 'text' : 'password'}
                                placeholder='Password'
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                            />
                            <img onClick={() => setIsPassVis(!isPassVis)} src={isPassVis ? passVis : passHide}
                                 alt="passVis"/>
                        </div>
                    </div>
                    <SpecialButton className={styles.submit} type="submit">Log in</SpecialButton>
                </form>
                <div></div>
            </div>
        </div>
    )
}
